import React from "react";
import { CalendarIcon, ChartIcon, CheckIcon, RocketIcon, UsersIcon } from "../Icons";
import { CONTAINER } from "../ui";
import { STAGES } from "../content";

const STAGE_ICONS = [RocketIcon, UsersIcon, CalendarIcon, ChartIcon];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      aria-labelledby="how-it-works-heading"
      className="tw-scroll-mt-24 tw-bg-[#10233f] tw-py-28 tw-text-white sm:tw-py-12"
    >
      <div className={CONTAINER}>
        <div className="tw-max-w-3xl">
          <p className="tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.15em] tw-text-[#70d9ce]">
            How it works
          </p>
          <h2
            id="how-it-works-heading"
            className="tw-mt-4 tw-mb-0 tw-text-5xl tw-font-black tw-leading-[1.04] tw-tracking-[-.045em] sm:tw-text-[2.25rem] sm:tw-leading-[1.1]"
          >
            Run your mentoring programme in one place.
          </h2>
          <p className="tw-mt-6 tw-mb-0 tw-text-lg tw-leading-8 tw-text-[#c2d3e2]">
            From getting people started to showing progress, we help your team manage four essential
            stages with less manual coordination.
          </p>
        </div>

        <ol
          aria-label="The four stages of running a mentoring programme"
          className="tw-mt-12 tw-mb-0 tw-grid tw-list-none tw-grid-cols-4 tw-gap-px tw-overflow-hidden tw-rounded-[24px] tw-border tw-border-white/15 tw-bg-white/15 tw-p-0 sm:tw-grid-cols-2 xs:tw-grid-cols-1"
        >
          {STAGES.map((stage, index) => {
            const Icon = STAGE_ICONS[index];

            return (
              <li key={stage.number} className="tw-flex tw-min-w-0 tw-flex-col tw-bg-[#10233f] tw-p-7 sm:tw-p-6">
                <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                  <span className="tw-text-sm tw-font-black tw-tracking-[.12em] tw-text-[#7fe8dc]">
                    {stage.number}
                  </span>
                  <span className="tw-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-xl tw-bg-[#087bd3] tw-text-white">
                    <Icon aria-hidden className="tw-h-5 tw-w-5" />
                  </span>
                </div>

                <h3 className="tw-mt-7 tw-mb-0 tw-min-h-14 tw-text-xl tw-font-black tw-leading-7 tw-tracking-[-.02em] sm:tw-min-h-0">
                  {stage.title}
                </h3>
                <p className="tw-mb-6 tw-mt-3 tw-text-sm tw-leading-6 tw-text-[#c2d3e2]">{stage.body}</p>

                <p className="tw-mt-auto tw-mb-0 tw-flex tw-items-start tw-gap-2 tw-border-t tw-border-white/10 tw-pt-5 tw-text-sm tw-font-bold tw-leading-6 tw-text-[#70d9ce]">
                  <CheckIcon aria-hidden className="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0" />
                  {stage.outcome}
                </p>
              </li>
            );
          })}
        </ol>

        <p className="tw-mt-7 tw-mb-0 tw-max-w-3xl tw-text-sm tw-leading-7 tw-text-[#c2d3e2]">
          <strong className="tw-font-bold tw-text-white">Your team stays in control.</strong> Use the
          platform on your own or add our support; the programme and the mentoring relationships stay
          yours.
        </p>
      </div>
    </section>
  );
}
